import React, { useState, useRef, useEffect, useContext } from 'react';
import './style.css';
import GetMeetQuollTextAlt1 from '/src/services/Content/GetMeetQuollTextAlt1';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { WindowSizeContext } from '/src/App';
import { CircleArrowRight } from 'lucide-react';
import StandardButton from '/src/Components/StandardButton/StandardButton';



// SVG Arrow component
const Arrow = ({ direction }) => {
    const getArrowPath = () => {
        switch (direction) {
            case 'right':
                return "M10 20 L50 20 L50 15 L65 25 L50 35 L50 30 L10 30 Z";
            case 'left':
                return "M65 20 L25 20 L25 15 L10 25 L25 35 L25 30 L65 30 Z";
            case 'down-right':
                return "M10 10 L30 30 L35 25 L50 40 L45 45 L30 30 L25 35 L10 15 Z";
            case 'down-left':
                return "M65 10 L45 30 L50 35 L35 45 L30 40 L45 30 L40 25 L60 10 Z";
            default:
                return "";
        }
    };

    return (
        <svg
            className="meet-quoll-arrow"
            viewBox="0 0 75 50"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d={getArrowPath()} fill="currentColor" />
        </svg>
    );
};

const MeetQuollSection = () => {
    const { deviceType } = useContext(WindowSizeContext);
    const sectionsContainerRef = useRef(null);
    const meetQuollSections = GetMeetQuollTextAlt1();


    const headlineText = "From Overwhelmed to Empowered With a Single Search"
    const introText = "Quoll is so much more than a risk assessment. Think of us like a crystal ball for your home and wallet, complete with a playbook for how you can protect yourself and start saving money."

    const buttonLinks = [
        {
            text: "What Our Analysis Covers",
            link: "/property-intelligence/whats-in-each-analysis"
        },
        {
            text: "Learn About Our Methodology",
            link: "/about/methodology"
        }
    ]

    const homeSceneImageFilename = "quoll-homepage-what-we-tell-you-v1.webp";
    const homeSceneImageUrl = CreateCloudfrontUrl(homeSceneImageFilename);

    const squigglyArrowImageFilename = "quoll-homepage-curved-arrow.svg";
    const squigglyArrowImageUrl = CreateCloudfrontUrl(squigglyArrowImageFilename);

    // Map sections to quadrant positions
    const getQuadrantClass = (stage) => {
        switch (stage) {
            case 1: return 'top-left';
            case 2: return 'bottom-left';
            case 3: return 'top-right';
            case 4: return 'bottom-right';
            default: return '';
        }
    };

    const getArrowDirection = (stage) => {
        switch (stage) {
            case 1: return 'down-right';
            case 2: return 'down-left';
            case 3: return 'right';
            case 4: return 'left';
            default: return 'right';
        }
    };

    //     quoll-connecting-dots-what-risks.webp
    // quoll-connecting-dots-what-cost.webp

    const understandingRiskImageFilename = "quoll-homepage-translating-your-risk.webp";
    const recommendedProjectsImageFilename = "quoll-homepage-recommended-projects.webp";
    const recommendedProjectsImageAlt1Filename = "quoll-homepage-recommended-projects_v2.webp";
    const recommendedProjectsImageAlt2Filename = "quoll-homepage-recommended-projects_v4.webp";
    const recommendedProjectsImageAlt3Filename = "quoll-homepage-recommended-projects_v5.webp";
    const gettingTheWorkDoneImageFilename = "quoll-homepage-getting-the-work-done.webp";
    const connectedDotsArray = [
        {
            step: 1,
            stepTitle: "Understand Your Risk in Dollars and Cents",
            image: understandingRiskImageFilename,
            alt: "Translating Climate to Dollars and Cents",
            description: "See which climate risks affect your home—translated into actual costs for repairs, insurance, utilities, property value, and more.",
            takeaway: "We'll Make This Easy to Understand"
        },
        {
            step: 2,
            stepTitle: "Recommendations With a Clear Payoff",
            image: recommendedProjectsImageAlt3Filename,
            alt: "Making Decisions",
            description: "Get a prioritized list of home improvements with exact savings for each, plus available rebates and insurance discounts.",
            takeaway: "Feel Confident in Your Choices"
        },
        {
            step: 3,
            stepTitle: "Help Taking Action When You're Ready",
            image: gettingTheWorkDoneImageFilename,
            alt: "Protecting Your Home",
            description: "Connect with local pros who can do the work, or tap into our DIY guides and resources library to tackle projects yourself.",
            takeaway: "Feel Empowered to Act"
        }
    ]

    return (
        <div className={`home-page-section-container ${deviceType}`}>
            <div className="home-page-section-title">
                <h2>{headlineText}</h2>
            </div>

            <div className={`meet-quoll-connected-dots-container ${deviceType}`}>
                {connectedDotsArray.map((dot, index) => (
                    <div key={`${dot.alt}-${index}`} className="meet-quoll-connected-dot">
                        <div className="meet-quoll-connected-dot-step-title-container">
                            <span className="meet-quoll-connected-dot-step-title">{dot.stepTitle}</span>
                        </div>
                        <div className="meet-quoll-connected-dot-image-container">
                            <img src={CreateCloudfrontUrl(dot.image)} alt={dot.alt} />
                        </div>
                        <div className="meet-quoll-connected-dot-text-container">
                            <span className="meet-quoll-connected-dot-text">{dot.description}</span>
                        </div>
                    </div>
                ))}
            </div>


            <div className={`meet-quoll-button-links ${deviceType}`}>
                {buttonLinks.map((button, index) => (
                    <StandardButton
                        id={`meet-quoll-button-${index}`}
                        text={button.text}
                        link={button.link}
                    />
                ))}
            </div>
        </div>
    );
};

export default MeetQuollSection;